// Copyright (c) 2017 Deere & Company

import ActionsPopoverCallback from '../../shared/state/actions-popover-callback';
import {hasAccess} from '../../shared/services/security';
import {hasPermission} from '../../shared/services/privacy';

const createCallBack = (label, onOptionClick, onOptionClickValues) =>
    new ActionsPopoverCallback({
        label,
        onOptionClick,
        onOptionClickValues
    });

export const getCustomerPanelActions = (context, customer, createRegistrationCallback) => {

    const actionList = [];

    if (hasAccess(context.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(context.user.privacy, 'registrationNotAllowed') && customer.type) {

        actionList.push(createCallBack('REGISTER_ANOTHER_PRODUCT', createRegistrationCallback.bind(null, customer)));

    }

    return actionList;

};



// WEBPACK FOOTER //
// ./src/shared/services/customer-panel-actions.js